import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=5d77c650&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingSpinner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=5d77c650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d77c650",
  null
  
)

export default component.exports